import React from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router";
import { AppLayout } from "./routes/AppLayout";
import { Dashboard } from "./routes/Dashboard";
import { Campaigns } from "./routes/Campaigns";
import { CampaignEditor } from "./routes/CampaignEditor";
import { Analytics } from "./routes/Analytics";
import { Settings } from "./routes/Settings";
import "./styles/app.css";

const router = createBrowserRouter([
  {
    path: "/",
    element: <AppLayout />,
    children: [
      { index: true, element: <Dashboard /> },
      { path: "campaigns", element: <Campaigns /> },
      { path: "campaigns/:id", element: <CampaignEditor /> },
      { path: "analytics", element: <Analytics /> },
      { path: "settings", element: <Settings /> },
    ],
  },
]);

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);
